import { type DeepWriteable } from '@shared/typings';
import { useCloned } from '@vueuse/core';

// Clone a DeepReadonly object and make the clone writable
export default <T>(original: T): DeepWriteable<T> => {
    // useCloned's default clone is JSON.parse(JSON.stringify(x)); JSON.stringify(undefined)
    // returns undefined, which JSON.parse then throws on. Nothing to clone anyway.
    if (typeof original === 'undefined') return original as DeepWriteable<T>;
    const writableOriginal: DeepWriteable<T> = original as DeepWriteable<T>;
    const { cloned } = useCloned(writableOriginal);
    return cloned.value;
};
